import { Route, Routes } from "react-router-dom";
import CourtPortalModule from ".";

const CourtPortalRoute = () => {
  return (
    <Routes>
      <Route path="/:view" element={<CourtPortalModule />} />
      <Route path="/:view/:calendarView" element={<CourtPortalModule />} />
      <Route path="/*" element={<CourtPortalModule />} />
    </Routes>
  );
};

export default CourtPortalRoute;
